import { canDeactivateGuard } from "src/app/models/UnsavedData/UnsavedData";
import { authGuard } from "./auth.guard";

export const guardMapping: { [key: string]: any } = {
	AuthGuard: authGuard,
	CanDeactivateGuard: canDeactivateGuard,
};
